import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { AuthState } from 'src/store/auth/types';

export default function useSessionLoading() {
  const { sessionLoading } = useSelector<RootState, AuthState>((state) => state.authState);
  return sessionLoading;
}
